/**
 * Google Tag Manager tracking utility
 * Pushes events to dataLayer for conversion tracking
 */

/**
 * Push event to Google Tag Manager dataLayer
 * @param {string} eventId - The event ID to track
 */
export const pushGTMEvent = (eventId) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventId,
    });
  } else if (typeof window !== "undefined") {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventId,
    });
  }
};

/**
 * Track account creation event
 * Event ID: account_creation
 */
export const trackAccountCreation = () => {
  pushGTMEvent("account_creation");
};

/**
 * Track full medical history intake completion
 * Event ID: medical_history_completed
 * Fires when status = "5" (all intake forms completed)
 */
export const trackMedicalHistoryCompleted = () => {
  pushGTMEvent("medical_history_completed");
};

/**
 * Track payment completed event
 * Event ID: payment_completed
 */
export const trackPaymentCompleted = () => {
  pushGTMEvent("payment_completed");
};

/**
 * Track symptoms tracker page visit
 * Event ID: symptoms_tracker_visited
 * Fires when user visits /app/symptoms-tracker route
 */
export const trackSymptomsTrackerVisited = () => {
  pushGTMEvent("symptoms_tracker_visited");
};
